import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { Col } from "antd";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { blockUser } from "services";

export const BlockUserButton = observer(() => {
  const { actionModals, userCard } = useStores();

  const clickHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Вы действительно хотите заблокировать пользователя?"
          successText="Пользователь заблокирован"
          buttonText="Заблокировать"
          calledQuery={() => blockUser({ id: userCard.card.id })}
          onSuccess={() => {
            setTimeout(() => userCard.fetchCardById(userCard.card.id), 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <Col>
      <CustomButton type="default" onClick={clickHandler} tooltip="Заблокировать пользователя">
        Заблокировать
      </CustomButton>
    </Col>
  );
});
